import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import { Router } from "react-router-dom";
import { createBrowserHistory } from 'history';
import App from './Contents/App';
import { ScrollToTop } from './Components/Common/ScrollToTop';
import './css/index.css';
import { registerAnalyticsPageView } from './Code/Utilities';

const history = createBrowserHistory();

history.listen(location => {
  registerAnalyticsPageView();
});


ReactDOM.render(
  <Router history={history}>
    <ScrollToTop>
      <App />
    </ScrollToTop>
  </Router>,
  document.getElementById('root')
);
